var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052b4"
    },
    width: 512,
    height: 341.337,
    y: 85.331
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 512,
    height: 113.775,
    y: 85.331
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 113.775,
    y: 312.882
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M129.468,181.793v85.136c0,48.429,63.267,63.267,63.267,63.267S256,315.356,256,266.929v-85.136 H129.468z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "155.634 196.634 229.835 196.634 229.835 166.953 214.994 174.373 192.733 152.113 170.474 174.373 155.634 166.953"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "241.16 278.782 192.929 230.551 144.698 278.782 160.439 294.522 192.929 262.032 225.419 294.522"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M241.16,233.734h-22.504c1.266-2.184,2.001-4.713,2.001-7.418c0-8.196-6.645-14.84-14.84-14.84 c-5.663,0-10.581,3.172-13.083,7.836c-2.502-4.663-7.421-7.836-13.083-7.836c-8.195,0-14.84,6.644-14.84,14.84 c0,2.706,0.736,5.235,2.001,7.418h-22.114c0,8.196,7.139,14.84,15.334,14.84h-0.494c0,8.196,6.644,14.84,14.84,14.84 c0,7.257,5.211,13.286,12.094,14.576l-11.694,26.401c5.603,2.278,11.727,3.544,18.149,3.544c6.422,0,12.545-1.266,18.149-3.544 l-11.694-26.401c6.883-1.29,12.094-7.319,12.094-14.576c8.196,0,14.84-6.644,14.84-14.84h-0.494 C234.021,248.574,241.16,241.93,241.16,233.734z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScc);
export default __webpack_public_path__ + "static/media/scc.88b78193eafd81ad802b56902aa94d87.svg";
export { ForwardRef as ReactComponent };